import React from "react";
import Helmet from "react-helmet";
import Layout from "../common/layouts/";
import Seo from "../common/seo";
import "tachyons";

export default () => (
  <Layout>
    <Seo title="FAQ" description="FAQ" />
    <Helmet>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>{" "}
    <div className="bg-style-bl pv5 flex flex-column items-center">
      <h1 className="db f1 display fw1"> Support and FAQ </h1>{" "}
      <p className="db sans-serif f5 tracked ttu tc">
        {" "}
        We’re always here to answer your questions and help you get the best out of Bookbot. You can chat to us live, or send us a message. We’ve also prepared a list of frequently asked questions.{" "}
      </p>{" "}
    </div>{" "}
    <div className="lh-copy f4 serif mw8 center">
      {" "}
      <h2>{" "}What is Bookbot? </h2>
      <h2>Can more than one child use the subscription?</h2>
      <h2>How much does Bookbot cost?{" "}</h2>
      <p>
        {" "}
        If you have any questions about Bookbot Pty Ltd, please contact us:{" "}
      </p>{" "}
      <ul>
        <li> by email contact@bookbotkids.com </li>{" "}
      </ul>{" "}
    </div>{" "}
  </Layout>
);
